// components/FormSelect.tsx
import React from "react";
import Select from "react-select";
import type { OptionsOrGroups } from "react-select"
import { Controller } from "react-hook-form"
import type { Control, FieldPath, FieldValues } from "react-hook-form";
import { Form } from "react-bootstrap";
import _ from "lodash";

interface Option {
  label: string;
  value: string | number;
}

interface FormSelectProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  options: OptionsOrGroups<Option, any>;
  placeholder?: string;
  label?: string;
  labelClassName?: string;
  className?: string;
  borderColor?: string;
  errorClassName?: string;
  isMulti?: boolean;
  formatOptionLabel?: (option: any) => React.ReactNode;
}

const FormSelect = <T extends FieldValues>({
  name,
  control,
  options,
  placeholder,
  label,
  labelClassName,
  className,
  borderColor,
  errorClassName,
  isMulti,
  formatOptionLabel
}: FormSelectProps<T>) => {
  const customStyles = (hasError: boolean) => ({
    control: (base: any) => ({
      ...base,
      borderColor: hasError ? "red" : borderColor ? borderColor : base.borderColor,
      "&:hover": {
        borderColor: hasError ? "red" : borderColor ? borderColor : base.borderColor,
      },
    }),
  });

  return (
    <>
      {label && (
        <Form.Label className={labelClassName ?? "mb-2"}>{label}</Form.Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => (
          <>
            <Select
              isMulti={isMulti ? isMulti : false}
              options={options}
              value={/*!field?.value?.value ? null :*/ field.value}
              onChange={/*field.onChange*/ (selected) => { field.onChange(selected) }}
              onBlur={field.onBlur}
              placeholder={placeholder ?? "Select..."}
              isClearable
              className={`${className ? className : '' }`}
              formatOptionLabel={formatOptionLabel}
              styles={customStyles(
                typeof _.get(errors, name)?.message === "string"
                  ? !!_.get(errors, name)?.message
                  : !!(_.get(errors, name) as any)?.value?.message
              )}
            />
            {_.get(errors, name) && (
              <Form.Text className={`${ errorClassName ? errorClassName : 'text-danger'}`}>
                {_.get(errors, name) &&
                  (typeof _.get(errors, name)?.message === "string"
                    ? _.get(errors, name)?.message
                    : (_.get(errors, name) as any)?.value?.message)}
              </Form.Text>
            )}
          </>
        )}
      />
    </>
  );
};

export default FormSelect;
